import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppAuth } from '@/contexts/app-auth.context'
import { Loader } from '@/components/ui/loader'

export function SignInPage() {
  const { user, isAuthLoading, signIn } = useAppAuth()
  const navigate = useNavigate()
  const [redirecting, setRedirecting] = useState(false)

  useEffect(() => {
    if (!isAuthLoading) {
      if (user) {
        // Already authenticated, redirect to dashboard
        setRedirecting(true)
        navigate('/dashboard')
      } else {
        // Not authenticated, redirect to WorkOS sign-in
        setRedirecting(true)
        signIn()
      }
    }
  }, [user, isAuthLoading, navigate, signIn])

  const getLoadingText = () => {
    if (isAuthLoading) return 'Checking authentication...'
    if (user && redirecting) return 'Redirecting to dashboard...'
    if (!user && redirecting) return 'Redirecting to sign in...'
    return 'Loading...'
  }

  return (
    <div className="h-screen overflow-hidden bg-black">
      <div className="flex min-h-screen items-center justify-center text-white">
        <Loader text={getLoadingText()} className="text-white" />
      </div>
    </div>
  )
}
